module.exports = __webpack_public_path__ + "static/media/nodejs.007baf9a.svg";